import type { DensityDefinition } from "daedalus-core";
import { VISION_MARGIN_TILES, widestLoadedView } from "../vision/vision.ts";
import { CREATURE_SPAWN } from "./type-names.ts";

/**
 * OdysseyTales's density registration (ADR-088 decision 6): the knob for the editor's density meter. The chunks are
 * measured over the widest view the game loads (`widestLoadedView`, a default zoom of 2 stepped Farther: 1728 by
 * 960, at most 5 by 4 chunks of 32 tiles). Creature spawns count as Creatures by their `count`, the creatures each
 * keeps, over the server's interest rectangle (the vision cap plus `VISION_MARGIN_TILES` on every side, centred on
 * the point), since creatures reach a client through the server and not through chunks. A group counts markers, and no
 * other marker type is registered: a shrine is a behaviour on a prop and is counted with the props. Props and Creatures are P2.0-T4's measured budgets (the Playbook's P2.0-T4 entry): props at 175
 * and 400 a chunk of the 20-chunk range, so a crossing column of 4 chunks creates about 700 and 1,600 images, the
 * stress world's 2,000 and 5,000 tiers, provisional until the GPU runs on the author's machines; creatures at 50 and
 * 100 in view. Animated props, atlas pages and tile chunks are still drafts ordered by the costs ADR-019
 * measured, since no GPU figures exist yet; a change here is a data edit.
 */

/**
 * The registration: the groups in the meter's order, each metric's amber and red thresholds and the loaded view.
 */
export const ODYSSEY_DENSITY: DensityDefinition = {
  groups: [
    { id: "creatures", label: "Creatures", types: [CREATURE_SPAWN], countField: "count", reach: { aroundView: { marginTiles: VISION_MARGIN_TILES } } },
  ],
  budgets: {
    props: { amber: 3500, red: 8000 },
    animated: { amber: 200, red: 500 },
    pages: { amber: 8, red: 16 },
    tileChunks: { amber: 32, red: 64 },
    creatures: { amber: 50, red: 100 },
  },
  view: widestLoadedView(),
};
